import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bell",
  "use": "icon-bell-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-bell\"><g fill=\"transparent\" stroke-width=\"1.5\" stroke=\"currentColor\"><circle cx=\"10\" cy=\"10\" r=\"9.25\" transform=\"translate(2 2)\" /><path d=\"M12.25 18a.25.25 0 11-.5 0H11v.75h2V18h-.75zm1.03-11.25h-2.23A2.25 2.25 0 008.8 9v4.808l-.672 2.116a.25.25 0 00.238.326h7.398a.25.25 0 00.245-.302l-.463-2.168-.016-.156V9a2.25 2.25 0 00-2.25-2.25z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol